export default __webpack_public_path__ + "static/media/animation.ea690968.png";